import React, { Component } from 'react'
import config from '../config.json'

const hasBackgroundTrailer = WrappedComponent => {
    class HasBackgroundTrailer extends Component {
        constructor(props) {
            super(props)
    
            this.state = {
                isReady: false,
                videoLoaded: false,
                trailerTime: 0,
                playVideoIntervallId: false,
                player: false
            }
    
            this.startPlayerTime = config.trailer.startTime
            this.stopPlayerTime = config.trailer.stopTime
    
            this.startCheckShouldStop = this.startCheckShouldStop.bind(this)
            this.stopCheckShouldStop = this.stopCheckShouldStop.bind(this)
            this.playPlayer = this.playPlayer.bind(this)
            this.onPlayerReady = this.onPlayerReady.bind(this)
            this.onPlayerStateChange = this.onPlayerStateChange.bind(this)
            this.onPlayerEnd = this.onPlayerEnd.bind(this)
            this.onPlayerUmount = this.onPlayerUmount.bind(this)
        }
    
        componentWillUnmount() {
            const { playVideoIntervallId } = this.state 
    
            playVideoIntervallId && clearInterval(playVideoIntervallId)
        }
    
        componentDidUpdate(prevProps, prevState) {
            const { props, state } = this
    
            const changeProps = this.initChangeProps(prevProps, props)


            if(!prevState.isReady && 'init' !== props.hasYoutubeCookieConfirmation && 'init' !== props.isConnectedFast) {
                this.setState({
                    isReady: true
                })
            }
    
            if(props.setTrailerItemsInView && (changeProps('isInViewport') || changeProps('maybeVideo'))) {
                props.setTrailerItemsInView(props.index, props.isInViewport && props.maybeVideo)
            }
    
            if(false !== prevState.playVideoIntervallId && prevState.playVideoIntervallId !== state.playVideoIntervallId) {
                clearInterval(prevState.playVideoIntervallId)
            }
        }
    
        initChangeProps(prev, curr) {
            return attr => prev[attr] !== curr[attr]
        }
    
        startCheckShouldStop() {
            const { player } = this.state
            const duration = player.getDuration()
            const stopTime = duration > this.stopPlayerTime ? duration - this.stopPlayerTime : 0.8 * duration
    
            const intervallId = setInterval(() => {         
                const currentTime = player.getCurrentTime()
    
                if(stopTime < currentTime) {
                    player.pauseVideo()
                }
            }, 400)
    
            this.setState({
                playVideoIntervallId: intervallId
            })
        }

        stopCheckShouldStop() {
            const { playVideoIntervallId } = this.state
    
            if(playVideoIntervallId) {
                clearInterval(playVideoIntervallId)
    
                this.setState({
                    playVideoIntervallId: false
                })
            }
        }
    
        playPlayer(playAgain = false) {
            const { player, trailerTime } = this.state
            const duration = player.getDuration()
            let startPlayerTime

            if(playAgain) {
                startPlayerTime = duration > this.startPlayerTime ? this.startPlayerTime : 0.3 * duration
            } else {
                startPlayerTime = trailerTime > 0 && trailerTime > this.startPlayerTime ? trailerTime : duration > this.startPlayerTime ? this.startPlayerTime : 0.3 * duration
            }

            player.seekTo(startPlayerTime, true)
            this.startCheckShouldStop()
        }

        onPlayerReady(event) {
            const player = event.target

            this.setState({
                player: player
            })

            this.playPlayer(false)
            this.startCheckShouldStop()
        }
    
        onPlayerStateChange(event) {
            const loaded = event.hasOwnProperty('data') && 1 === event.data

            this.setState(prevState => {
                if(loaded !== prevState.videoLoaded) {
                    return {
                        ...prevState,
                        videoLoaded: loaded
                    }
                } else {
                    return null
                }
            })
        }
        
        onPlayerEnd() {
            const { player } = this.state
            this.playPlayer(true)
            player.playVideo()
        }

        onPlayerUmount()  {
            const { player, trailerTime } = this.state
            let currentTime = trailerTime

            if(player && player.g)  {
                currentTime = parseInt(player.getCurrentTime())
            }

            this.stopCheckShouldStop()
            this.setState({
                player: false,
                trailerTime: currentTime,
                videoLoaded: false
            })
        }
        
        render() {
            const { isReady, videoLoaded, trailerTime } = this.state

            const injectedProps = {
                isReady: isReady,
                videoLoaded: videoLoaded,
                trailerTime: trailerTime,
                onPlayerReady: this.onPlayerReady,
                onPlayerStateChange: this.onPlayerStateChange,
                onPlayerEnd: this.onPlayerEnd,
                onPlayerUmount: this.onPlayerUmount
            }
            
            return <WrappedComponent
                {...this.props}
                {...injectedProps}
            />
        }
    }

    return HasBackgroundTrailer
}

export default hasBackgroundTrailer